/**
 * Quantity Breaks / Bundle & Save Component
 * Compatible with Vastras theme
 */

if (!customElements.get('quantity-breaks')) {
  class QuantityBreaks extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.updatePrices = this.dataset.updatePrices === 'true';
      this.skipUnavailable = this.dataset.skipUnavailable === 'true';
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      
      const jsonEl = this.querySelector('.quantity-breaks-json');
      try {
        this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      } catch (e) {
        this.variants = [];
      }

      this.initElements();
      this.bindEvents();
      this.syncActiveTier();
    }

    initElements() {
      this.radios = this.querySelectorAll('input[name="quantity_breaks_option"]');
      this.labels = this.querySelectorAll('.quantity-break');
      this.container = this.closest('.product-template') || this.closest('.product-single') || document;
      this.form = this.container.querySelector('form[action*="/cart/add"]') || document.getElementById(`AddToCartForm-${this.sectionId}`) || document.querySelector('form[action*="/cart/add"]');
      this.atcButton = this.container.querySelector('#AddToCart-' + this.sectionId) || this.container.querySelector('button[name="add"]') || (this.form ? this.form.querySelector('button[type="submit"]') : null);
      this.buyNowButton = this.container.querySelector('.product-form__buynow') || this.container.querySelector('.shopify-payment-button');
    }

    bindEvents() {
      // Radio change event
      this.radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          this.handleTierChange(radio);
        });
      });

      // Dropdown changes inside each tier
      this.querySelectorAll('.quantity-break__variant-select').forEach((select) => {
        select.addEventListener('change', (e) => {
          this.handleDropdownChange(e.target);
        });
      });

      // Listen for main variant change on product page to sync option 1 and dynamic prices
      if (this.sectionId) {
        $(document).on(`variantChange.product-${this.sectionId}`, (e, variant) => {
          if (variant) this.handleMainVariantChange(variant);
        });
      }

      // Handle Buy Now button click
      if (this.buyNowButton) {
        $(this.buyNowButton).on('click', (e) => {
          const payload = this.collectItemsPayload();
          if (payload && payload.length > 0) {
            const isSingleDefault = payload.length === 1 && payload[0].quantity === 1;
            if (!isSingleDefault) {
              e.preventDefault();
              e.stopImmediatePropagation();
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: payload })
              })
              .then(() => {
                window.location.href = '/checkout';
              })
              .catch(() => {
                window.location.href = '/checkout';
              });
            }
          }
        });
      }
    }

    getSelectedRadio() {
      return this.querySelector('input[name="quantity_breaks_option"]:checked') || this.radios[0];
    }

    getSelectedLabel() {
      const radio = this.getSelectedRadio();
      return radio ? this.querySelector(`label[for="${radio.id}"]`) : null;
    }

    getCurrentBaseVariant() {
      const currentId = this.form?.querySelector('[name="id"]')?.value;
      if (currentId) {
        const v = this.variants.find(item => item.id == currentId);
        if (v) return v;
      }
      return this.variants[0] || null;
    }

    getVariantForSelectorItem(selectorItem) {
      if (!selectorItem) return this.getCurrentBaseVariant();

      const selects = selectorItem.querySelectorAll('.quantity-break__variant-select');
      if (selects.length === 0) {
        return this.getCurrentBaseVariant();
      }

      const selectedOptions = Array.from(selects).map(s => (s.value || '').trim());

      const matchedVariant = this.variants.find((variant) => {
        if (selects.length === 1) {
          return String(variant.option1).trim() === String(selectedOptions[0]).trim();
        } else if (selects.length === 2) {
          return String(variant.option1).trim() === String(selectedOptions[0]).trim() &&
                 String(variant.option2).trim() === String(selectedOptions[1]).trim();
        } else if (selects.length === 3) {
          return String(variant.option1).trim() === String(selectedOptions[0]).trim() &&
                 String(variant.option2).trim() === String(selectedOptions[1]).trim() &&
                 String(variant.option3).trim() === String(selectedOptions[2]).trim();
        }
        return false;
      });

      return matchedVariant || this.getCurrentBaseVariant();
    }

    handleTierChange(radio) {
      const qty = parseInt(radio.value, 10) || 1;
      
      // Update form quantity input
      if (this.form) {
        const qtyInput = this.form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = qty;
        }
      }

      this.updateDynamicPrices();
    }

    handleDropdownChange(select) {
      const selectorItem = select.closest('.quantity-break__selector-item');
      if (!selectorItem) return;

      const matchedVariant = this.getVariantForSelectorItem(selectorItem);

      if (matchedVariant) {
        selectorItem.dataset.selectedId = matchedVariant.id;
        
        // Update availability styling
        if (!matchedVariant.available) {
          select.classList.add('is-sold-out');
        } else {
          select.classList.remove('is-sold-out');
        }

        // If tier has 1 item, also update main form
        const radio = selectorItem.closest('.quantity-break')?.previousElementSibling;
        if (radio && parseInt(radio.value, 10) === 1 && this.form) {
          const mainSelect = this.form.querySelector('[name="id"]');
          if (mainSelect && mainSelect.value != matchedVariant.id) {
            mainSelect.value = matchedVariant.id;
            $(mainSelect).trigger('change');
          }
        }
      }

      if (this.updatePrices) {
        this.updateDynamicPrices();
      }
    }

    handleMainVariantChange(variant) {
      if (!variant) return;

      // Update dropdowns on row #1 across all tiers to match selected variant
      this.querySelectorAll('.quantity-break__selector-item[data-select-index="0"]').forEach((item) => {
        item.dataset.selectedId = variant.id;
        const selects = item.querySelectorAll('.quantity-break__variant-select');
        if (selects[0] && variant.option1) selects[0].value = variant.option1;
        if (selects[1] && variant.option2) selects[1].value = variant.option2;
        if (selects[2] && variant.option3) selects[2].value = variant.option3;
      });

      this.updateDynamicPrices(variant);
    }

    formatMoney(cents) {
      if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat || this.moneyFormat);
      }
      return '₹ ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
    }

    updateDynamicPrices(baseVariant) {
      const activeVariant = baseVariant || (this.variants.find(v => v.id == this.container.querySelector('[name="id"]')?.value) || this.variants[0]);
      if (!activeVariant) return;

      const price = activeVariant.price;
      const comparePrice = activeVariant.compare_at_price > price ? activeVariant.compare_at_price : price;

      this.labels.forEach((label) => {
        const qty = parseInt(label.dataset.quantity, 10) || 1;
        const percentageLeft = parseFloat(label.dataset.percentageLeft) || 1;
        const fixedDiscount = parseInt(label.dataset.fixedDiscount, 10) || 0;

        const tierPrice = Math.max(0, Math.round(price * qty * percentageLeft) - fixedDiscount);
        const tierComparePrice = comparePrice * qty;
        const savedAmount = Math.max(0, tierComparePrice - tierPrice);
        const savedAmountRounded = Math.ceil(savedAmount / 100) * 100;
        const priceEach = Math.round(tierPrice / qty);
        const comparePriceEach = Math.round(tierComparePrice / qty);

        // Update elements with dynamic price texts
        label.querySelectorAll('.variant-price-update').forEach((el) => {
          const rawText = el.dataset.text;
          if (!rawText) return;

          let replaced = rawText
            .replace(/\[quantity\]/g, qty)
            .replace(/\[price\]/g, this.formatMoney(tierPrice))
            .replace(/\[compare_price\]/g, this.formatMoney(tierComparePrice))
            .replace(/\[amount_saved\]/g, this.formatMoney(savedAmount))
            .replace(/\[amount_saved_rounded\]/g, this.formatMoney(savedAmountRounded))
            .replace(/\[price_each\]/g, this.formatMoney(priceEach))
            .replace(/\[compare_price_each\]/g, this.formatMoney(comparePriceEach));

          el.innerHTML = replaced;
        });
      });
    }

    syncActiveTier() {
      const selectedRadio = this.getSelectedRadio();
      if (selectedRadio) {
        this.handleTierChange(selectedRadio);
      }
    }

    collectItemsPayload() {
      const activeLabel = this.getSelectedLabel();
      if (!activeLabel) return null;

      const qty = parseInt(activeLabel.dataset.quantity, 10) || 1;
      const selectorItems = activeLabel.querySelectorAll('.quantity-break__selector-item');
      const counts = {};

      if (selectorItems.length > 0) {
        selectorItems.forEach((item) => {
          const variant = this.getVariantForSelectorItem(item);
          if (variant && variant.id) {
            counts[variant.id] = (counts[variant.id] || 0) + 1;
          }
        });
      } else {
        const base = this.getCurrentBaseVariant();
        if (base && base.id) {
          counts[base.id] = qty;
        }
      }

      const items = Object.keys(counts).map(id => ({
        id: parseInt(id, 10),
        quantity: counts[id]
      }));

      return items;
    }
  }

  customElements.define('quantity-breaks', QuantityBreaks);
}
